// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"750":"11e281c7","879":"595ae680"}[chunkId] + ".chunk.js";
};